import { useState } from "react";
import {
  getStorageMode,
  setStorageMode,
  type StorageMode,
} from "@/features/settings/storage/preferences";

export function usePreferences() {
  const [storageMode, setStorageModeState] = useState<StorageMode>(getStorageMode);

  function updateStorageMode(mode: StorageMode) {
    setStorageMode(mode);
    setStorageModeState(mode);
  }

  return {
    storageMode,
    updateStorageMode,
  };
}
